import { useState, useEffect } from 'react';
import { useUserContext } from '../../../hooks/useUserContext';
import { useTranslation } from 'react-i18next';
import ImageMap from '../../welten/ImageMap';
import "./Behinderung.css";

export default function Behinderung({oldAndNewScore}) {
    const { t } = useTranslation();
    //variables for score and state updating
    const { games, updateGames, calculateScore, score } = useUserContext();
    const behinderung = games.behinderung;
    const max_points = games.behinderung.points_max;

    //set up image map variables
    const height = window.innerHeight*0.6;
    const imgSrc = "Suchbild_Behinderung.png";
    const imgWidth = (height/611)*1500;
    const viewbox = "0 0 " + imgWidth.toString() + " " + height.toString();
    const factor = height/611;
    const imgMap = {
        imgSrc: imgSrc,
        areas: [
          {
            id: 1,
            name: 'behinderung1',
            type: 'rect',
            x: 255,
            y: 168,
            width: 71,
            height: 116,
          },
          {
            id: 2,
            name: 'behinderung2',
            type: 'rect',
            x: 165,
            y: 430,
            width: 313,
            height: 101,
          },
          {
            id: 3,
            name: 'behinderung3',
            type: 'rect',
            x: 9,
            y: 262,
            width: 165,
            height: 132,
          },
          {
            id: 4,
            name: 'behinderung4',
            type: 'rect',
            x: 411,
            y: 305,
            width: 76,
            height: 91,
          }
        ],
    }

    const [wimmelbilder, setWimmelbilder] = useState({
        behinderung1: false,
        behinderung2: false,
        behinderung3: false,
        behinderung4: false
    });

    const [text, setText] = useState(t('behinderung.start_text'));

    const clicked = (event, name) => {
        if (name!=="nope") {
            setWimmelbilder(wimmelbilder => ({...wimmelbilder, [name]: true}));
            event.target.id="active";
            show_message(name);
        } else if (name === "nope") {
            event.target.id="wrong";
            show_message("bad");
        };
        
    };

    const [wimmelbild_msg, setWimmelbildMsg] = useState("");
    const show_message = (state) => {
        if (state !== "bad") {
            setWimmelbildMsg(t(`behinderung.${state}`));
        } else if (state === "bad") {
            setWimmelbildMsg(t('behinderung.wrong'));
        };
        document.getElementById("wimmelbild_message_behinderung").style.display = "flex";
        setTimeout(() => document.getElementById("wimmelbild_message_behinderung").style.display="none", 4000);
    };

    useEffect(() => {
        let finished_temp = true;
        for (const value of Object.values(wimmelbilder)) {
            if (value === false) {
                finished_temp = false;
            };
        };
        if (finished_temp === true) {
            setText(t('behinderung.finish_text'));
            const behinderung_new = { ...behinderung, state: 'done', points_achieved: max_points };
            const games_new = { ...games, behinderung: behinderung_new };
            updateGames(games_new);
            const current_game = "behinderung";
            let total_score = calculateScore(current_game);
            total_score += max_points;
            const oldScore = score;
            const newScore = total_score;
            oldAndNewScore(oldScore, newScore);
            //updateScore(total_score);
            setTimeout(() => {
                setWimmelbildMsg(t('behinderung.finished'));
                document.getElementById("wimmelbild_message_behinderung").style.display="flex";
                }
                , 1500);
        };
    },[wimmelbilder]);

    return (
        <div className="wimmelbild">
            <h2>{text}</h2>
            <div className="wrapper_wimmelbild" style={{ width: "100%", height: "65vh", overflowX: "auto", overflowY: "auto" }}>
                <ImageMap clicked={clicked} factor={factor} imgWidth={imgWidth} viewbox={viewbox} height={height} imgMap={imgMap} folder="game"/>
            </div>
            <div className="wimmelbild_message_behinderung" id="wimmelbild_message_behinderung">
                <p>{wimmelbild_msg}</p>
            </div>
        </div>
    )
}